import * as z from "zod"

// Helper schema for JSON fields
type Literal = boolean | number | string
type Json = Literal | { [key: string]: Json } | Json[]
const literalSchema = z.union([z.string(), z.number(), z.boolean()])
const jsonSchema: z.ZodSchema<Json> = z.lazy(() => z.union([literalSchema, z.array(jsonSchema), z.record(z.string(), jsonSchema)]))

export const AuditLogDbModel = z.object({
  id: z.string(),
  timestamp: z.coerce.date(),
  type: z.string(),
  userId: z.string().nullish(),
  workspaceId: z.string().nullish(),
  objectId: z.string().nullish(),
  changes: jsonSchema,
})
